/* eslint-disable import/prefer-default-export */

const TierTypes = {
    FlexLeague: {
        id: 13,
        name: 'flexleague',
    },
};

export {
    TierTypes,
};
